module.exports = __webpack_public_path__ + "img/vertical_4_7_8011.8c511b87.png";